import { useMemo } from 'react';
import Link, { buildLinkUrl } from '../links/Link';
import { useStatusColor } from '../../utilities/ColorUtilities';
import { useFilterState } from '../../stores/FilterStateStore';
import { usePageState } from '../../stores/PageStateStore';

const TRANSPARENT = 'transparent';

function StatusLink(props) {
    const { column, row } = props;
    const [filterState] = useFilterState();
    const [pageState] = usePageState();
    const targetUrl = useMemo(
        () => buildLinkUrl(column.link, row, filterState, pageState),
        [column, row, filterState, pageState]
    );
    const status = column.mapper(row, column);

    if (!status) {
        return <MatrixStatusBlock color={TRANSPARENT} />;
    }

    const worst = status?.worst;
    return (
        <Link to={targetUrl}>
            <MatrixStatusBlock color={worst} />
        </Link>
    );
}

function MatrixStatusBlock({ color }) {
    const statusColor = useStatusColor(color);
    let styles = { fill: statusColor };
    if (TRANSPARENT === color) {
        styles = { fill: TRANSPARENT, stroke: 'transparent', strokeWidth: '0px' };
    }

    return (
        <svg viewBox="0 0 100 100" style={{ verticalAlign: 'middle' }}>
            <rect x="0" y="0" width="100" height="100" style={styles} />
        </svg>
    );
}

export function statusLinkRenderer(row, column) {
    return <StatusLink column={column} row={row} />;
}
